import matkonto from './matkonto';
import myPoints from './myPoints';
import myProfile from './myProfile';

export default {
    matkonto,
    myPoints,
    myProfile,
};
